// extracted by mini-css-extract-plugin
module.exports = {"confirm-modal":"ConfirmActionModal_confirm-modal__2Nvnw","confirm-text":"ConfirmActionModal_confirm-text__b0_ps"};